// Format any (minor units, ISO-4217 code) pair using the locale-correct
// symbol / placement. AUD shows "$124.00", EUR shows "€49.90", and so on.
export function formatMoney(
  minor: number | null | undefined,
  currency: string = "AUD",
): string {
  if (minor == null) return "—";
  try {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(minor / 100);
  } catch {
    // ------ unknown currency code: fall back to plain "<code> 12.34"
    return `${currency} ${(minor / 100).toFixed(2)}`;
  }
}

// Back-compat alias for the AUD-only summary columns.
export function formatAud(cents: number | null | undefined): string {
  return formatMoney(cents, "AUD");
}

// Compact "$124" style — whole units, no fractional digits. For the dense table
// "Mdn $" column where the spread already lives in a separate ± clause.
export function formatMoneyWhole(
  minor: number | null | undefined,
  currency: string = "AUD",
): string {
  if (minor == null) return "—";
  try {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(minor / 100);
  } catch {
    return `${currency} ${Math.round(minor / 100)}`;
  }
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-AU", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
